import { CdkService, FindSpecificVehicleResponse } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useFindSpecificVehicleQuery = (
  vehicleId: string,
  options?: Omit<UseQueryOptions<FindSpecificVehicleResponse, QueryError>, 'queryKey' | 'queryFn'>
) =>
  useQuery<FindSpecificVehicleResponse, QueryError>(
    ['findSpecificVehicle', vehicleId],
    () => CdkService.getCdkVehiclesVehicleFindSpecific(vehicleId),
    {
      enabled: !!vehicleId,
      ...options
    }
  );
